import _get from "lodash/get";
import { getInstitution, getProduct } from './common';
/**
 * Get the URL of the logo.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The logo URL
 */

export var getImageSrc = function getImageSrc(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.logo_url.value');
};
/**
 * Get the logo alt text.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The alt text for the logo.
 */

export var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getIssuerName(marketplaceEntity);
};
/**
 * Get the issuer name.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */

export var getIssuerName = function getIssuerName(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.name.value');
};
/**
 * Get the issuer review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */

export var getIssuerReviewLink = function getIssuerReviewLink(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.review_url.value');
};
/**
 * Get the "learn more" / review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The "learn more" / review link.
 */

export var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return getProductReviewLink(marketplaceEntity);
};
/**
 * Get the product review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */

export var getProductReviewLink = function getProductReviewLink(marketplaceEntity) {
  return _get(getProduct(marketplaceEntity), 'details.review_url.value');
};
/**
 * Get the name of the product / service provided.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The name
 */

export var getName = function getName(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.name.value');
};
/**
 * Get the bonus value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The bonus value
 */

export var getBonus = function getBonus(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.bonus.value');
};
/**
 * Get the bonus details.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The bonus details
 */

export var getBonusDetails = function getBonusDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.bonus_details.value');
};
/**
 * Get the price value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The price value
 */

export var getPrice = function getPrice(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.price.value');
};
/**
 * Get the price details.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String[]} The price details
 */

export var getPriceDetails = function getPriceDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.price_details.value');
};
/**
 * Get the price frequency value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The price frequency value
 */

export var getPriceFrequency = function getPriceFrequency(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.price_frequency.value');
};
/**
 * Get the payments cost value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The payments cost value
 */

export var getPaymentsCost = function getPaymentsCost(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.payments_cost.value');
};
/**
 * Get the hardware cost value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The hardware cost value
 */

export var getHardwareCost = function getHardwareCost(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.hardware_cost.value');
};
/**
 * Get the software cost value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The software cost value
 */

export var getSoftwareCost = function getSoftwareCost(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.software_cost.value');
};
/**
 * Get the product category value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The product category value
 */

export var getProductCategory = function getProductCategory(marketplaceEntity) {
  return _get(marketplaceEntity, 'product.details.category.value');
};
/**
 * Get the payments details value.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {Number} The payments details value
 */

export var getPaymentsDetails = function getPaymentsDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.payments_details.value');
};